var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C37.7025 5.15406e-07 48 10.2975 48 23V25C48 37.7025 37.7025 48 25 48H23C10.2975 48 0 37.7025 0 25V23C5.1544e-07 10.2975 10.2975 0 23 0H25Z",
    fill: "#D9F7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7431 34.6663H26.3327C31.824 34.6663 34.0205 32.533 34.0205 27.1997V20.7997C34.0205 15.4663 31.824 13.333 26.3327 13.333H19.7431C14.2517 13.333 12.0552 15.4663 12.0552 20.7997V27.1997C12.0552 32.533 14.2517 34.6663 19.7431 34.6663Z",
    stroke: "#66C997",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.403 20.7686L17.6683 23.4246C17.3498 23.7339 17.3498 24.2566 17.6683 24.5659L20.403 27.2219",
    stroke: "#66C997",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6737 20.7671L28.4084 23.4231C28.7269 23.7324 28.7269 24.2551 28.4084 24.5644L25.6737 27.2204",
    stroke: "#66C997",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeSquare);
export default __webpack_public_path__ + "static/media/codeSquare.317dc0e2864e1758d4cf394244daf719.svg";
export { ForwardRef as ReactComponent };